// extracted by mini-css-extract-plugin
module.exports = {"v-icon":"NsAddressZa_v-icon_bWWR6","nsAddressForm":"NsAddressZa_nsAddressForm_2ZyXX","dualColumn":"NsAddressZa_dualColumn_1nHCs","firstCol":"NsAddressZa_firstCol_9irl9"};